const industries = [
  {
    "code": "01",
    "name": "Agriculture, animal husbandry, game farming and related service activities",
    "subIndustries": [
      {
        "code": "011",
        "name": "Cultivation of non-perennial crops",
        "subSubIndustries": [
          { "code": "0111", "name": "Cultivation of cereals (except rice), leguminous crops and oil seeds" },
          { "code": "0112", "name": "Cultivation of rice" },
          { "code": "0113", "name": "Growing of vegetables, melons, roots and tuber plants" },
          { "code": "0114", "name": "Cultivation of sugar cane" },
          { "code": "0115", "name": "Cultivation of tobacco" },
          { "code": "0116", "name": "Cultivation of fiber crops" },
          { "code": "0119", "name": "Cultivation of other non-perennial crops" }
        ]
      },
      {
        "code": "012",
        "name": "Cultivation of perennial crops",
        "subSubIndustries": [
          { "code": "0121", "name": "Viticulture" },
          { "code": "0122", "name": "Cultivation of tropical fruit" },
          { "code": "0123", "name": "Cultivation of citrus fruit" },
          { "code": "0124", "name": "Cultivation of pome fruit and stone fruit" },
          { "code": "0125", "name": "Cultivation of other fruit, tree and bush fruit" },
          { "code": "0126", "name": "Cultivation of oily fruit" },
          { "code": "0127", "name": "Cultivation of beverage crops" },
          { "code": "0128", "name": "Cultivation of spices, aromas, narcotics, herbs" },
          { "code": "0129", "name": "Cultivation of other perennial crops" }
        ]
      },
      {
        "code": "013",
        "name": "Cultivation of plant propagating material",
        "subSubIndustries": [
          { "code": "0130", "name": "Cultivation of plant propagating material" }
        ]
      },
      {
        "code": "014",
        "name": "Animal husbandry",
        "subSubIndustries": [
          { "code": "0141", "name": "Rearing of cattle, dairy farming" },
          { "code": "0142", "name": "Rearing of other cattle" },
          { "code": "0143", "name": "Rearing of horses and other equines" },
          { "code": "0144", "name": "Rearing of camels and camelids" },
          { "code": "0145", "name": "Rearing of sheep and goats" },
          { "code": "0146", "name": "Rearing of swine" },
          { "code": "0147", "name": "Rearing of poultry" },
          { "code": "0149", "name": "Rearing of other animals" }
        ]
      },
      {
        "code": "015",
        "name": "Mixed farming",
        "subSubIndustries": [
          { "code": "0150", "name": "Mixed farming" }
        ]
      },
      {
        "code": "016",
        "name": "Agricultural and postharvest services",
        "subSubIndustries": [
          { "code": "0161", "name": "Crop production services" },
          { "code": "0162", "name": "Animal husbandry services" },
          { "code": "0163", "name": "Post-harvest service" },
          { "code": "0164", "name": "Seed processing for sowing" }
        ]
      },
      {
        "code": "017",
        "name": "Game farming, game management services",
        "subSubIndustries": [
          { "code": "0170", "name": "Game farming, game management services" }
        ]
      }
    ]
  },
  {
    "code": "02",
    "name": "Forestry",
    "subIndustries": [
      {
        "code": "021",
        "name": "Forestry and other forestry activities",
        "subSubIndustries": [
          { "code": "0210", "name": "Forestry and other forestry activities" }
        ]
      },
      {
        "code": "022",
        "name": "Logging",
        "subSubIndustries": [
          { "code": "0220", "name": "Logging" }
        ]
      },
      {
        "code": "023",
        "name": "Collection of other wild forest products",
        "subSubIndustries": [
          { "code": "0230", "name": "Collection of other wild forest products" }
        ]
      },
      {
        "code": "024",
        "name": "Forestry service",
        "subSubIndustries": [
          { "code": "0240", "name": "Forestry service" }
        ]
      }
    ]
  },
  {
    "code": "03",
    "name": "Fishing, fish farming",
    "subIndustries": [
      {
        "code": "031",
        "name": "Fishing",
        "subSubIndustries": [
          { "code": "0311", "name": "Sea fishing" },
          { "code": "0312", "name": "Freshwater fishing" }
        ]
      },
      {
        "code": "032",
        "name": "Fish farming",
        "subSubIndustries": [
          { "code": "0321", "name": "Sea fish farming" },
          { "code": "0322", "name": "Freshwater fish farming" }
        ]
      }
    ]
  },
  {
    "code": "05",
    "name": "Mining of coal and lignite",
    "subIndustries": [
      {
        "code": "051",
        "name": "Mining of hard coal",
        "subSubIndustries": [
          { "code": "0510", "name": "Mining of hard coal" }
        ]
      },
      {
        "code": "052",
        "name": "Mining of lignite",
        "subSubIndustries": [
          { "code": "0520", "name": "Mining of lignite" }
        ]
      }
    ]
  },
  {
    "code": "06",
    "name": "Extraction of crude petroleum and natural gas",
    "subIndustries": [
      {
        "code": "061",
        "name": "Extraction of crude petroleum",
        "subSubIndustries": [
          { "code": "0610", "name": "Extraction of crude petroleum" }
        ]
      },
      {
        "code": "062",
        "name": "Extraction of natural gas",
        "subSubIndustries": [
          { "code": "0620", "name": "Extraction of natural gas" }
        ]
      }
    ]
  },
  {
    "code": "07",
    "name": "Mining of metal ores",
    "subIndustries": [
      {
        "code": "071",
        "name": "Mining of iron ores",
        "subSubIndustries": [
          { "code": "0710", "name": "Mining of iron ores" }
        ]
      },
      {
        "code": "072",
        "name": "Mining of non-ferrous metal ores",
        "subSubIndustries": [
          { "code": "0721", "name": "Mining of uranium and thorium ores" },
          { "code": "0729", "name": "Mining of other non-ferrous metal ores" }
        ]
      }
    ]
  },
  {
    "code": "08",
    "name": "Other mining and quarrying",
    "subIndustries": [
      {
        "code": "081",
        "name": "Quarrying of stone, sand and clay",
        "subSubIndustries": [
          { "code": "0811", "name": "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate" },
          { "code": "0812", "name": "Operation of gravel and sand pits, mining of clays and kaolin" }
        ]
      },
      {
        "code": "089",
        "name": "Mining and quarrying of other minerals",
        "subSubIndustries": [
          { "code": "0891", "name": "Mining of chemical and fertilizer minerals" },
          { "code": "0892", "name": "Extraction of peat" },
          { "code": "0893", "name": "Extraction of salt" },
          { "code": "0899", "name": "Other mining and quarrying not elsewhere classified" }
        ]
      }
    ]
  },
  {
    "code": "09",
    "name": "Mining support service activities",
    "subIndustries": [
      {
        "code": "091",
        "name": "Support activities for petroleum and natural gas extraction",
        "subSubIndustries": [
          { "code": "0910", "name": "Support activities for petroleum and natural gas extraction" }
        ]
      },
      {
        "code": "099",
        "name": "Support activities for other mining and quarrying",
        "subSubIndustries": [
          { "code": "0990", "name": "Support activities for other mining and quarrying" }
        ]
      }
    ]
  },
  {
    "code": "10",
    "name": "Manufacture of food products",
    "subIndustries": [
      {
        "code": "101",
        "name": "Processing and preserving of meat and meat products",
        "subSubIndustries": [
          { "code": "1011", "name": "Processing and preserving of meat" },
          { "code": "1012", "name": "Processing and preserving of poultry meat" },
          { "code": "1013", "name": "Production of meat and poultry meat products" }
        ]
      },
      {
        "code": "102",
        "name": "Processing and preserving of fish, crustaceans and mollusks",
        "subSubIndustries": [
          { "code": "1020", "name": "Processing and preserving of fish, crustaceans and mollusks" }
        ]
      },
      {
        "code": "103",
        "name": "Processing and preserving of fruit and vegetables",
        "subSubIndustries": [
          { "code": "1031", "name": "Processing and preserving of potatoes" },
          { "code": "1032", "name": "Manufacture of fruit and vegetable juice" },
          { "code": "1039", "name": "Other processing and preserving of fruit and vegetables" }
        ]
      },
      {
        "code": "104",
        "name": "Manufacture of vegetable and animal oils and fats",
        "subSubIndustries": [
          { "code": "1041", "name": "Manufacture of oils and fats" },
          { "code": "1042", "name": "Manufacture of margarine and similar edible fats" }
        ]
      },
      {
        "code": "105",
        "name": "Manufacture of dairy products",
        "subSubIndustries": [
          { "code": "1051", "name": "Operation of dairies and cheese making" },
          { "code": "1052", "name": "Manufacture of ice cream" }
        ]
      },
      {
        "code": "106",
        "name": "Manufacture of grain mill products, starches and starch products",
        "subSubIndustries": [
          { "code": "1061", "name": "Manufacture of grain mill products" },
          { "code": "1062", "name": "Manufacture of starches and starch products" }
        ]
      },
      {
        "code": "107",
        "name": "Manufacture of bakery and farinaceous products",
        "subSubIndustries": [
          { "code": "1071", "name": "Manufacture of bread; manufacture of fresh pastry goods and cakes" },
          { "code": "1072", "name": "Manufacture of rusks and biscuits; manufacture of preserved pastry goods and cakes" },
          { "code": "1073", "name": "Manufacture of macaroni, noodles, couscous and similar farinaceous products" }
        ]
      },
      {
        "code": "108",
        "name": "Manufacture of other food products",
        "subSubIndustries": [
          { "code": "1081", "name": "Manufacture of sugar" },
          { "code": "1082", "name": "Manufacture of cocoa, chocolate and sugar confectionery" },
          { "code": "1083", "name": "Processing of tea and coffee" },
          { "code": "1084", "name": "Manufacture of condiments and seasonings" },
          { "code": "1085", "name": "Manufacture of prepared meals and dishes" },
          { "code": "1086", "name": "Manufacture of homogenized food preparations and dietetic food" },
          { "code": "1089", "name": "Manufacture of other food products not elsewhere classified" }
        ]
      },
      {
        "code": "109",
        "name": "Manufacture of prepared animal feeds",
        "subSubIndustries": [
          { "code": "1091", "name": "Manufacture of prepared feeds for farm animals" },
          { "code": "1092", "name": "Manufacture of prepared pet foods" }
        ]
      }
    ]
  },
  {
    "code": "11",
    "name": "Manufacture of beverages",
    "subIndustries": [
      {
        "code": "110",
        "name": "Manufacture of beverages",
        "subSubIndustries": [
          { "code": "1101", "name": "Distilling, rectifying and blending of spirits" },
          { "code": "1102", "name": "Manufacture of wine from grape" },
          { "code": "1103", "name": "Manufacture of cider and other fruit wines" },
          { "code": "1104", "name": "Manufacture of other non-distilled fermented beverages" },
          { "code": "1105", "name": "Manufacture of beer" },
          { "code": "1106", "name": "Manufacture of malt" },
          { "code": "1107", "name": "Manufacture of soft drinks; production of mineral waters and other bottled waters" }
        ]
      }
    ]
  },
  {
    "code": "12",
    "name": "Manufacture of tobacco products",
    "subIndustries": [
      {
        "code": "120",
        "name": "Manufacture of tobacco products",
        "subSubIndustries": [
          { "code": "1200", "name": "Manufacture of tobacco products" }
        ]
      }
    ]
  },
  {
    "code": "13",
    "name": "Manufacture of textiles",
    "subIndustries": [
      {
        "code": "131",
        "name": "Preparation and spinning of textile fibres",
        "subSubIndustries": [
          { "code": "1310", "name": "Preparation and spinning of textile fibres" }
        ]
      },
      {
        "code": "132",
        "name": "Weaving of textiles",
        "subSubIndustries": [
          { "code": "1320", "name": "Weaving of textiles" }
        ]
      },
      {
        "code": "133",
        "name": "Finishing of textiles",
        "subSubIndustries": [
          { "code": "1330", "name": "Finishing of textiles" }
        ]
      },
      {
        "code": "139",
        "name": "Manufacture of other textiles",
        "subSubIndustries": [
          { "code": "1391", "name": "Manufacture of knitted and crocheted fabrics" },
          { "code": "1392", "name": "Manufacture of made-up textile articles, except apparel" },
          { "code": "1393", "name": "Manufacture of carpets and rugs" },
          { "code": "1394", "name": "Manufacture of cordage, rope, twine and netting" },
          { "code": "1395", "name": "Manufacture of non-wovens and articles made from non-wovens, except apparel" },
          { "code": "1396", "name": "Manufacture of other technical and industrial textiles" },
          { "code": "1399", "name": "Manufacture of other textiles not elsewhere classified" }
        ]
      }
    ]
  },
  {
    "code": "14",
    "name": "Manufacture of wearing apparel",
    "subIndustries": [
      {
        "code": "141",
        "name": "Manufacture of wearing apparel, except fur apparel",
        "subSubIndustries": [
          { "code": "1411", "name": "Manufacture of leather clothes" },
          { "code": "1412", "name": "Manufacture of workwear" },
          { "code": "1413", "name": "Manufacture of other outerwear" },
          { "code": "1414", "name": "Manufacture of underwear" }
        ]
      },
      {
        "code": "142",
        "name": "Manufacture of articles of fur",
        "subSubIndustries": [
          { "code": "1420", "name": "Manufacture of articles of fur" }
        ]
      },
      {
        "code": "143",
        "name": "Manufacture of knitted and crocheted apparel",
        "subSubIndustries": [
          { "code": "1431", "name": "Manufacture of knitted and crocheted hosiery" },
          { "code": "1439", "name": "Manufacture of other knitted and crocheted apparel" }
        ]
      }
    ]
  },
  {
    "code": "15",
    "name": "Manufacture of leather and related products",
    "subIndustries": [
      {
        "code": "151",
        "name": "Tanning and dressing of leather; manufacture of luggage, handbags, saddlery and harness; dressing and dyeing of fur",
        "subSubIndustries": [
          { "code": "1511", "name": "Tanning and dressing of leather; dressing and dyeing of fur" },
          { "code": "1512", "name": "Manufacture of luggage, handbags and the like, saddlery and harness" }
        ]
      },
      {
        "code": "152",
        "name": "Manufacture of footwear",
        "subSubIndustries": [
          { "code": "1520", "name": "Manufacture of footwear" }
        ]
      }
    ]
  },
  {
    "code": "16",
    "name": "Manufacture of wood and products of wood and cork, except furniture; manufacture of articles of straw and plaiting materials",
    "subIndustries": [
      {
        "code": "161",
        "name": "Sawmilling and planing of wood",
        "subSubIndustries": [
          { "code": "1610", "name": "Sawmilling and planing of wood" }
        ]
      },
      {
        "code": "162",
        "name": "Manufacture of products of wood, cork, straw and plaiting materials",
        "subSubIndustries": [
          { "code": "1621", "name": "Manufacture of veneer sheets and wood-based panels" },
          { "code": "1622", "name": "Manufacture of assembled parquet floors" },
          { "code": "1623", "name": "Manufacture of other builders’ carpentry and joinery" },
          { "code": "1624", "name": "Manufacture of wooden containers" },
          { "code": "1629", "name": "Manufacture of other products of wood; manufacture of articles of cork, straw and plaiting materials" }
        ]
      }
    ]
  },
  {
    "code": "17",
    "name": "Manufacture of paper and paper products",
    "subIndustries": [
      {
        "code": "171",
        "name": "Manufacture of pulp, paper and paperboard",
        "subSubIndustries": [
          { "code": "1711", "name": "Manufacture of pulp" },
          { "code": "1712", "name": "Manufacture of paper and paperboard" }
        ]
      },
      {
        "code": "172",
        "name": "Manufacture of articles of paper and paperboard",
        "subSubIndustries": [
          { "code": "1721", "name": "Manufacture of corrugated paper and paperboard and of containers of paper and paperboard" },
          { "code": "1722", "name": "Manufacture of household and sanitary goods and of toilet requisites" },
          { "code": "1723", "name": "Manufacture of paper stationery" },
          { "code": "1724", "name": "Manufacture of wallpaper" },
          { "code": "1729", "name": "Manufacture of other articles of paper and paperboard" }
        ]
      }
    ]
  },
  {
    "code": "18",
    "name": "Printing and reproduction of recorded media",
    "subIndustries": [
      {
        "code": "181",
        "name": "Printing and service activities related to printing",
        "subSubIndustries": [
          { "code": "1811", "name": "Printing of newspapers" },
          { "code": "1812", "name": "Other printing" },
          { "code": "1813", "name": "Pre-press and pre-media services" },
          { "code": "1814", "name": "Binding and related services" }
        ]
      },
      {
        "code": "182",
        "name": "Reproduction of recorded media",
        "subSubIndustries": [
          { "code": "1820", "name": "Reproduction of recorded media" }
        ]
      }
    ]
  },
  {
    "code": "19",
    "name": "Manufacture of coke and refined petroleum products",
    "subIndustries": [
      {
        "code": "191",
        "name": "Manufacture of coke oven products",
        "subSubIndustries": [
          { "code": "1910", "name": "Manufacture of coke oven products" }
        ]
      },
      {
        "code": "192",
        "name": "Manufacture of refined petroleum products",
        "subSubIndustries": [
          { "code": "1920", "name": "Manufacture of refined petroleum products" }
        ]
      }
    ]
  },
  {
    "code": "20",
    "name": "Manufacture of chemicals and chemical products",
    "subIndustries": [
      {
        "code": "201",
        "name": "Manufacture of basic chemicals, fertilisers and nitrogen compounds, plastics and synthetic rubber in primary forms",
        "subSubIndustries": [
          { "code": "2011", "name": "Manufacture of industrial gases" },
          { "code": "2012", "name": "Manufacture of dyes and pigments" },
          { "code": "2013", "name": "Manufacture of other inorganic basic chemicals" },
          { "code": "2014", "name": "Manufacture of other organic basic chemicals" },
          { "code": "2015", "name": "Manufacture of fertilisers and nitrogen compounds" },
          { "code": "2016", "name": "Manufacture of plastics in primary forms" },
          { "code": "2017", "name": "Manufacture of synthetic rubber in primary forms" }
        ]
      },
      {
        "code": "202",
        "name": "Manufacture of pesticides and other agrochemical products",
        "subSubIndustries": [
          { "code": "2020", "name": "Manufacture of pesticides and other agrochemical products" }
        ]
      },
      {
        "code": "203",
        "name": "Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
        "subSubIndustries": [
          { "code": "2030", "name": "Manufacture of paints, varnishes and similar coatings, printing ink and mastics" }
        ]
      },
      {
        "code": "204",
        "name": "Manufacture of soap and detergents, cleaning and polishing preparations, perfumes and toilet preparations",
        "subSubIndustries": [
          { "code": "2041", "name": "Manufacture of soap and detergents, cleaning and polishing preparations" },
          { "code": "2042", "name": "Manufacture of perfumes and toilet preparations" }
        ]
      },
      {
        "code": "205",
        "name": "Manufacture of other chemical products",
        "subSubIndustries": [
          { "code": "2051", "name": "Manufacture of explosives" },
          { "code": "2052", "name": "Manufacture of glues" },
          { "code": "2053", "name": "Manufacture of essential oils" },
          { "code": "2059", "name": "Manufacture of other chemical products n.e.c." }
        ]
      },
      {
        "code": "206",
        "name": "Manufacture of man-made fibres",
        "subSubIndustries": [
          { "code": "2060", "name": "Manufacture of man-made fibres" }
        ]
      }
    ]
  },
  {
    "code": "21",
    "name": "Manufacture of basic pharmaceutical products and pharmaceutical preparations",
    "subIndustries": [
      {
        "code": "211",
        "name": "Manufacture of basic pharmaceutical products",
        "subSubIndustries": [
          { "code": "2110", "name": "Manufacture of basic pharmaceutical products" }
        ]
      },
      {
        "code": "212",
        "name": "Manufacture of pharmaceutical preparations",
        "subSubIndustries": [
          { "code": "2120", "name": "Manufacture of pharmaceutical preparations" }
        ]
      }
    ]
  },
  {
    "code": "22",
    "name": "Manufacture of rubber and plastic products",
    "subIndustries": [
      {
        "code": "221",
        "name": "Manufacture of rubber products",
        "subSubIndustries": [
          { "code": "2211", "name": "Manufacture of rubber tyres and tubes; retreading and rebuilding of rubber tyres" },
          { "code": "2219", "name": "Manufacture of other rubber products" }
        ]
      },
      {
        "code": "222",
        "name": "Manufacture of plastic products",
        "subSubIndustries": [
          { "code": "2221", "name": "Manufacture of plastic plates, sheets, tubes and profiles" },
          { "code": "2222", "name": "Manufacture of plastic packing goods" },
          { "code": "2223", "name": "Manufacture of builders’ ware of plastic" },
          { "code": "2229", "name": "Manufacture of other plastic products" }
        ]
      }
    ]
  },
  {
    "code": "23",
    "name": "Manufacture of other non-metallic mineral products",
    "subIndustries": [
      {
        "code": "231",
        "name": "Manufacture of glass and glass products",
        "subSubIndustries": [
          { "code": "2311", "name": "Manufacture of flat glass" },
          { "code": "2312", "name": "Shaping and processing of flat glass" },
          { "code": "2313", "name": "Manufacture of hollow glass" },
          { "code": "2314", "name": "Manufacture of glass fibres" },
          { "code": "2319", "name": "Manufacture and processing of other glass, including technical glassware" }
        ]
      },
      {
        "code": "232",
        "name": "Manufacture of refractory products",
        "subSubIndustries": [
          { "code": "2320", "name": "Manufacture of refractory products" }
        ]
      },
      {
        "code": "233",
        "name": "Manufacture of clay building materials",
        "subSubIndustries": [
          { "code": "2331", "name": "Manufacture of ceramic tiles and flags" },
          { "code": "2332", "name": "Manufacture of bricks, tiles and construction products, in baked clay" }
        ]
      },
      {
        "code": "234",
        "name": "Manufacture of other porcelain and ceramic products",
        "subSubIndustries": [
          { "code": "2341", "name": "Manufacture of ceramic household and ornamental articles" },
          { "code": "2342", "name": "Manufacture of ceramic sanitary fixtures" },
          { "code": "2343", "name": "Manufacture of ceramic insulators and insulating fittings" },
          { "code": "2344", "name": "Manufacture of other technical ceramic products" },
          { "code": "2349", "name": "Manufacture of other ceramic products" }
        ]
      },
      {
        "code": "235",
        "name": "Manufacture of cement, lime and plaster",
        "subSubIndustries": [
          { "code": "2351", "name": "Manufacture of cement" },
          { "code": "2352", "name": "Manufacture of lime and plaster" }
        ]
      },
      {
        "code": "236",
        "name": "Manufacture of articles of concrete, cement and plaster",
        "subSubIndustries": [
          { "code": "2361", "name": "Manufacture of concrete products for construction purposes" },
          { "code": "2362", "name": "Manufacture of plaster products for construction purposes" },
          { "code": "2363", "name": "Manufacture of ready-mixed concrete" },
          { "code": "2364", "name": "Manufacture of mortars" },
          { "code": "2365", "name": "Manufacture of fibre cement" },
          { "code": "2369", "name": "Manufacture of other articles of concrete, plaster and cement" }
        ]
      },
      {
        "code": "237",
        "name": "Cutting, shaping and finishing of stone",
        "subSubIndustries": [
          { "code": "2370", "name": "Cutting, shaping and finishing of stone" }
        ]
      },
      {
        "code": "239",
        "name": "Manufacture of abrasive products and non-metallic mineral products n.e.c.",
        "subSubIndustries": [
          { "code": "2391", "name": "Production of abrasive products" },
          { "code": "2399", "name": "Manufacture of other non-metallic mineral products n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "24",
    "name": "Manufacture of basic metals",
    "subIndustries": [
      {
        "code": "241",
        "name": "Manufacture of basic iron and steel and of ferro-alloys",
        "subSubIndustries": [
          { "code": "2410", "name": "Manufacture of basic iron and steel and of ferro-alloys" }
        ]
      },
      {
        "code": "242",
        "name": "Manufacture of tubes, pipes, hollow profiles and related fittings, of steel",
        "subSubIndustries": [
          { "code": "2420", "name": "Manufacture of tubes, pipes, hollow profiles and related fittings, of steel" }
        ]
      },
      {
        "code": "243",
        "name": "Other first processing of iron and steel",
        "subSubIndustries": [
          { "code": "2431", "name": "Cold drawing of bars" },
          { "code": "2432", "name": "Cold rolling of narrow strip" },
          { "code": "2433", "name": "Cold forming or folding" },
          { "code": "2434", "name": "Cold drawing of wire" }
        ]
      },
      {
        "code": "244",
        "name": "Manufacture of basic precious and other non-ferrous metals",
        "subSubIndustries": [
          { "code": "2441", "name": "Precious metals production" },
          { "code": "2442", "name": "Aluminium production" },
          { "code": "2443", "name": "Lead, zinc and tin production" },
          { "code": "2444", "name": "Copper production" },
          { "code": "2445", "name": "Other non-ferrous metal production" }
        ]
      },
      {
        "code": "245",
        "name": "Casting of metals",
        "subSubIndustries": [
          { "code": "2451", "name": "Casting of iron" },
          { "code": "2452", "name": "Casting of steel" },
          { "code": "2453", "name": "Casting of light metals" },
          { "code": "2454", "name": "Casting of other non-ferrous metals" }
        ]
      }
    ]
  },
  {
    "code": "25",
    "name": "Manufacture of fabricated metal products, except machinery and equipment",
    "subIndustries": [
      {
        "code": "251",
        "name": "Manufacture of structural metal products",
        "subSubIndustries": [
          { "code": "2511", "name": "Manufacture of metal structures and parts of structures" },
          { "code": "2512", "name": "Manufacture of doors and windows of metal" }
        ]
      },
      {
        "code": "252",
        "name": "Manufacture of tanks, reservoirs and containers of metal",
        "subSubIndustries": [
          { "code": "2521", "name": "Manufacture of central heating radiators and boilers" },
          { "code": "2529", "name": "Manufacture of other tanks, reservoirs and containers of metal" }
        ]
      },
      {
        "code": "253",
        "name": "Manufacture of steam generators, except central heating hot water boilers",
        "subSubIndustries": [
          { "code": "2530", "name": "Manufacture of steam generators, except central heating hot water boilers" }
        ]
      },
      {
        "code": "254",
        "name": "Manufacture of weapons and ammunition",
        "subSubIndustries": [
          { "code": "2540", "name": "Manufacture of weapons and ammunition" }
        ]
      },
      {
        "code": "255",
        "name": "Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
        "subSubIndustries": [
          { "code": "2550", "name": "Forging, pressing, stamping and roll-forming of metal; powder metallurgy" }
        ]
      },
      {
        "code": "256",
        "name": "Treatment and coating of metals; machining",
        "subSubIndustries": [
          { "code": "2561", "name": "Treatment and coating of metals" },
          { "code": "2562", "name": "Machining" }
        ]
      },
      {
        "code": "257",
        "name": "Manufacture of cutlery, tools and general hardware",
        "subSubIndustries": [
          { "code": "2571", "name": "Manufacture of cutlery" },
          { "code": "2572", "name": "Manufacture of locks and hinges" },
          { "code": "2573", "name": "Manufacture of tools" }
        ]
      },
      {
        "code": "259",
        "name": "Manufacture of other fabricated metal products",
        "subSubIndustries": [
          { "code": "2591", "name": "Manufacture of steel drums and similar containers" },
          { "code": "2592", "name": "Manufacture of light metal packaging" },
          { "code": "2593", "name": "Manufacture of wire products, chain and springs" },
          { "code": "2594", "name": "Manufacture of fasteners and screw machine products" },
          { "code": "2599", "name": "Manufacture of other fabricated metal products n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "26",
    "name": "Manufacture of computer, electronic and optical products",
    "subIndustries": [
      {
        "code": "261",
        "name": "Manufacture of electronic components and boards",
        "subSubIndustries": [
          { "code": "2611", "name": "Manufacture of electronic components" },
          { "code": "2612", "name": "Manufacture of loaded electronic boards" }
        ]
      },
      {
        "code": "262",
        "name": "Manufacture of computers and peripheral equipment",
        "subSubIndustries": [
          { "code": "2620", "name": "Manufacture of computers and peripheral equipment" }
        ]
      },
      {
        "code": "263",
        "name": "Manufacture of communication equipment",
        "subSubIndustries": [
          { "code": "2630", "name": "Manufacture of communication equipment" }
        ]
      },
      {
        "code": "264",
        "name": "Manufacture of consumer electronics",
        "subSubIndustries": [
          { "code": "2640", "name": "Manufacture of consumer electronics" }
        ]
      },
      {
        "code": "265",
        "name": "Manufacture of instruments and appliances for measuring, testing and navigation; watches and clocks",
        "subSubIndustries": [
          { "code": "2651", "name": "Manufacture of instruments and appliances for measuring, testing and navigation" },
          { "code": "2652", "name": "Manufacture of watches and clocks" }
        ]
      },
      {
        "code": "266",
        "name": "Manufacture of irradiation, electromedical and electrotherapeutic equipment",
        "subSubIndustries": [
          { "code": "2660", "name": "Manufacture of irradiation, electromedical and electrotherapeutic equipment" }
        ]
      },
      {
        "code": "267",
        "name": "Manufacture of optical instruments and photographic equipment",
        "subSubIndustries": [
          { "code": "2670", "name": "Manufacture of optical instruments and photographic equipment" }
        ]
      },
      {
        "code": "268",
        "name": "Manufacture of magnetic and optical media",
        "subSubIndustries": [
          { "code": "2680", "name": "Manufacture of magnetic and optical media" }
        ]
      }
    ]
  },
  {
    "code": "27",
    "name": "Manufacture of electrical equipment",
    "subIndustries": [
      {
        "code": "271",
        "name": "Manufacture of electric motors, generators, transformers and electricity distribution and control apparatus",
        "subSubIndustries": [
          { "code": "2711", "name": "Manufacture of electric motors, generators and transformers" },
          { "code": "2712", "name": "Manufacture of electricity distribution and control apparatus" }
        ]
      },
      {
        "code": "272",
        "name": "Manufacture of batteries and accumulators",
        "subSubIndustries": [
          { "code": "2720", "name": "Manufacture of batteries and accumulators" }
        ]
      },
      {
        "code": "273",
        "name": "Manufacture of wiring and wiring devices",
        "subSubIndustries": [
          { "code": "2731", "name": "Manufacture of fibre optic cables" },
          { "code": "2732", "name": "Manufacture of other electronic and electric wires and cables" },
          { "code": "2733", "name": "Manufacture of wiring devices" }
        ]
      },
      {
        "code": "274",
        "name": "Manufacture of electric lighting equipment",
        "subSubIndustries": [
          { "code": "2740", "name": "Manufacture of electric lighting equipment" }
        ]
      },
      {
        "code": "275",
        "name": "Manufacture of domestic appliances",
        "subSubIndustries": [
          { "code": "2751", "name": "Manufacture of electric domestic appliances" },
          { "code": "2752", "name": "Manufacture of non-electric domestic appliances" }
        ]
      },
      {
        "code": "279",
        "name": "Manufacture of other electrical equipment",
        "subSubIndustries": [
          { "code": "2790", "name": "Manufacture of other electrical equipment" }
        ]
      }
    ]
  },
  {
    "code": "28",
    "name": "Manufacture of machinery and equipment n.e.c.",
    "subIndustries": [
      {
        "code": "281",
        "name": "Manufacture of general-purpose machinery",
        "subSubIndustries": [
          { "code": "2811", "name": "Manufacture of engines and turbines, except aircraft, vehicle and cycle engines" },
          { "code": "2812", "name": "Manufacture of fluid power equipment" },
          { "code": "2813", "name": "Manufacture of other pumps and compressors" },
          { "code": "2814", "name": "Manufacture of other taps and valves" },
          { "code": "2815", "name": "Manufacture of bearings, gears, gearing and driving elements" }
        ]
      },
      {
        "code": "282",
        "name": "Manufacture of other general-purpose machinery",
        "subSubIndustries": [
          { "code": "2821", "name": "Manufacture of ovens, furnaces and furnace burners" },
          { "code": "2822", "name": "Manufacture of lifting and handling equipment" },
          { "code": "2823", "name": "Manufacture of office machinery and equipment (except computers and peripheral equipment)" },
          { "code": "2824", "name": "Manufacture of power-driven hand tools" },
          { "code": "2825", "name": "Manufacture of non-domestic cooling and ventilation equipment" },
          { "code": "2829", "name": "Manufacture of other general-purpose machinery n.e.c." }
        ]
      },
      {
        "code": "283",
        "name": "Manufacture of agricultural and forestry machinery",
        "subSubIndustries": [
          { "code": "2830", "name": "Manufacture of agricultural and forestry machinery" }
        ]
      },
      {
        "code": "284",
        "name": "Manufacture of metal forming machinery and machine tools",
        "subSubIndustries": [
          { "code": "2841", "name": "Manufacture of metal forming machinery" },
          { "code": "2849", "name": "Manufacture of other machine tools" }
        ]
      },
      {
        "code": "289",
        "name": "Manufacture of other special-purpose machinery",
        "subSubIndustries": [
          { "code": "2891", "name": "Manufacture of machinery for metallurgy" },
          { "code": "2892", "name": "Manufacture of machinery for mining, quarrying and construction" },
          { "code": "2893", "name": "Manufacture of machinery for food, beverage and tobacco processing" },
          { "code": "2894", "name": "Manufacture of machinery for textile, apparel and leather production" },
          { "code": "2895", "name": "Manufacture of machinery for paper and paperboard production" },
          { "code": "2896", "name": "Manufacture of plastics and rubber machinery" },
          { "code": "2899", "name": "Manufacture of other special-purpose machinery n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "29",
    "name": "Manufacture of motor vehicles, trailers and semi-trailers",
    "subIndustries": [
      {
        "code": "291",
        "name": "Manufacture of motor vehicles",
        "subSubIndustries": [
          { "code": "2910", "name": "Manufacture of motor vehicles" }
        ]
      },
      {
        "code": "292",
        "name": "Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi-trailers",
        "subSubIndustries": [
          { "code": "2920", "name": "Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi-trailers" }
        ]
      },
      {
        "code": "293",
        "name": "Manufacture of parts and accessories for motor vehicles",
        "subSubIndustries": [
          { "code": "2931", "name": "Manufacture of electrical and electronic equipment for motor vehicles" },
          { "code": "2932", "name": "Manufacture of other parts and accessories for motor vehicles" }
        ]
      }
    ]
  },
  {
    "code": "30",
    "name": "Manufacture of other transport equipment",
    "subIndustries": [
      {
        "code": "301",
        "name": "Building of ships and boats",
        "subSubIndustries": [
          { "code": "3011", "name": "Building of ships and floating structures" },
          { "code": "3012", "name": "Building of pleasure and sporting boats" }
        ]
      },
      {
        "code": "302",
        "name": "Manufacture of railway locomotives and rolling stock",
        "subSubIndustries": [
          { "code": "3020", "name": "Manufacture of railway locomotives and rolling stock" }
        ]
      },
      {
        "code": "303",
        "name": "Manufacture of air and spacecraft and related machinery",
        "subSubIndustries": [
          { "code": "3030", "name": "Manufacture of air and spacecraft and related machinery" }
        ]
      },
      {
        "code": "304",
        "name": "Manufacture of military fighting vehicles",
        "subSubIndustries": [
          { "code": "3040", "name": "Manufacture of military fighting vehicles" }
        ]
      },
      {
        "code": "309",
        "name": "Manufacture of transport equipment n.e.c.",
        "subSubIndustries": [
          { "code": "3091", "name": "Manufacture of motorcycles" },
          { "code": "3092", "name": "Manufacture of bicycles and invalid carriages" },
          { "code": "3099", "name": "Manufacture of other transport equipment n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "31",
    "name": "Manufacture of furniture",
    "subIndustries": [
      {
        "code": "310",
        "name": "Manufacture of furniture",
        "subSubIndustries": [
          { "code": "3101", "name": "Manufacture of office and shop furniture" },
          { "code": "3102", "name": "Manufacture of kitchen furniture" },
          { "code": "3103", "name": "Manufacture of mattresses" },
          { "code": "3109", "name": "Manufacture of other furniture" }
        ]
      }
    ]
  },
  {
    "code": "32",
    "name": "Other manufacturing",
    "subIndustries": [
      {
        "code": "321",
        "name": "Manufacture of jewellery, bijouterie and related articles",
        "subSubIndustries": [
          { "code": "3211", "name": "Striking of coins" },
          { "code": "3212", "name": "Manufacture of jewellery and related articles" },
          { "code": "3213", "name": "Manufacture of imitation jewellery and related articles" }
        ]
      },
      {
        "code": "322",
        "name": "Manufacture of musical instruments",
        "subSubIndustries": [
          { "code": "3220", "name": "Manufacture of musical instruments" }
        ]
      },
      {
        "code": "323",
        "name": "Manufacture of sports goods",
        "subSubIndustries": [
          { "code": "3230", "name": "Manufacture of sports goods" }
        ]
      },
      {
        "code": "324",
        "name": "Manufacture of games and toys",
        "subSubIndustries": [
          { "code": "3240", "name": "Manufacture of games and toys" }
        ]
      },
      {
        "code": "325",
        "name": "Manufacture of medical and dental instruments and supplies",
        "subSubIndustries": [
          { "code": "3250", "name": "Manufacture of medical and dental instruments and supplies" }
        ]
      },
      {
        "code": "329",
        "name": "Other manufacturing n.e.c.",
        "subSubIndustries": [
          { "code": "3291", "name": "Manufacture of brooms and brushes" },
          { "code": "3299", "name": "Other manufacturing n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "33",
    "name": "Repair and installation of machinery and equipment",
    "subIndustries": [
      {
        "code": "331",
        "name": "Repair of fabricated metal products, machinery and equipment",
        "subSubIndustries": [
          { "code": "3311", "name": "Repair of fabricated metal products" },
          { "code": "3312", "name": "Repair of machinery" },
          { "code": "3313", "name": "Repair of electronic and optical equipment" },
          { "code": "3314", "name": "Repair of electrical equipment" },
          { "code": "3315", "name": "Repair and maintenance of ships and boats" },
          { "code": "3316", "name": "Repair and maintenance of aircraft and spacecraft" },
          { "code": "3317", "name": "Repair and maintenance of transport equipment n.e.c." },
          { "code": "3319", "name": "Repair of other equipment" }
        ]
      },
      {
        "code": "332",
        "name": "Installation of industrial machinery and equipment",
        "subSubIndustries": [
          { "code": "3320", "name": "Installation of industrial machinery and equipment" }
        ]
      }
    ]
  },
  {
    "code": "35",
    "name": "Electricity, gas, steam and air conditioning supply",
    "subIndustries": [
      {
        "code": "351",
        "name": "Electric power generation, transmission and distribution",
        "subSubIndustries": [
          { "code": "3511", "name": "Production of electricity" },
          { "code": "3512", "name": "Transmission of electricity" },
          { "code": "3513", "name": "Distribution of electricity" },
          { "code": "3514", "name": "Trade of electricity" }
        ]
      },
      {
        "code": "352",
        "name": "Manufacture of gas; distribution of gaseous fuels through mains",
        "subSubIndustries": [
          { "code": "3521", "name": "Manufacture of gas" },
          { "code": "3522", "name": "Distribution of gaseous fuels through mains" },
          { "code": "3523", "name": "Trade of gas through mains" }
        ]
      },
      {
        "code": "353",
        "name": "Steam and air conditioning supply",
        "subSubIndustries": [
          { "code": "3530", "name": "Steam and air conditioning supply" }
        ]
      }
    ]
  },
  {
    "code": "36",
    "name": "Water collection, treatment and supply",
    "subIndustries": [
      {
        "code": "360",
        "name": "Water collection, treatment and supply",
        "subSubIndustries": [
          { "code": "3600", "name": "Water collection, treatment and supply" }
        ]
      }
    ]
  },
  {
    "code": "37",
    "name": "Sewerage",
    "subIndustries": [
      {
        "code": "370",
        "name": "Sewerage",
        "subSubIndustries": [
          { "code": "3700", "name": "Sewerage" }
        ]
      }
    ]
  },
  {
    "code": "38",
    "name": "Waste collection, treatment and disposal activities; materials recovery",
    "subIndustries": [
      {
        "code": "381",
        "name": "Waste collection",
        "subSubIndustries": [
          { "code": "3811", "name": "Collection of non-hazardous waste" },
          { "code": "3812", "name": "Collection of hazardous waste" }
        ]
      },
      {
        "code": "382",
        "name": "Waste treatment and disposal",
        "subSubIndustries": [
          { "code": "3821", "name": "Treatment and disposal of non-hazardous waste" },
          { "code": "3822", "name": "Treatment and disposal of hazardous waste" }
        ]
      },
      {
        "code": "383",
        "name": "Materials recovery",
        "subSubIndustries": [
          { "code": "3831", "name": "Dismantling of wrecks" },
          { "code": "3832", "name": "Recovery of sorted materials" }
        ]
      }
    ]
  },
  {
    "code": "39",
    "name": "Remediation activities and other waste management services",
    "subIndustries": [
      {
        "code": "390",
        "name": "Remediation activities and other waste management services",
        "subSubIndustries": [
          { "code": "3900", "name": "Remediation activities and other waste management services" }
        ]
      }
    ]
  },
  {
    "code": "41",
    "name": "Construction of buildings",
    "subIndustries": [
      {
        "code": "411",
        "name": "Development of building projects",
        "subSubIndustries": [
          { "code": "4110", "name": "Development of building projects" }
        ]
      },
      {
        "code": "412",
        "name": "Construction of residential and non-residential buildings",
        "subSubIndustries": [
          { "code": "4120", "name": "Construction of residential and non-residential buildings" }
        ]
      }
    ]
  },
  {
    "code": "42",
    "name": "Civil engineering",
    "subIndustries": [
      {
        "code": "421",
        "name": "Construction of roads and railways",
        "subSubIndustries": [
          { "code": "4211", "name": "Construction of roads and motorways" },
          { "code": "4212", "name": "Construction of railways and underground railways" },
          { "code": "4213", "name": "Construction of bridges and tunnels" }
        ]
      },
      {
        "code": "422",
        "name": "Construction of utility projects",
        "subSubIndustries": [
          { "code": "4221", "name": "Construction of utility projects for fluids" },
          { "code": "4222", "name": "Construction of utility projects for electricity and telecommunications" }
        ]
      },
      {
        "code": "429",
        "name": "Construction of other civil engineering projects",
        "subSubIndustries": [
          { "code": "4291", "name": "Construction of water projects" },
          { "code": "4299", "name": "Construction of other civil engineering projects n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "43",
    "name": "Specialised construction activities",
    "subIndustries": [
      {
        "code": "431",
        "name": "Demolition and site preparation",
        "subSubIndustries": [
          { "code": "4311", "name": "Demolition" },
          { "code": "4312", "name": "Site preparation" },
          { "code": "4313", "name": "Test drilling and boring" }
        ]
      },
      {
        "code": "432",
        "name": "Electrical, plumbing and other construction installation activities",
        "subSubIndustries": [
          { "code": "4321", "name": "Electrical installation" },
          { "code": "4322", "name": "Plumbing, heat and air-conditioning installation" },
          { "code": "4329", "name": "Other construction installation" }
        ]
      },
      {
        "code": "433",
        "name": "Building completion and finishing",
        "subSubIndustries": [
          { "code": "4331", "name": "Plastering" },
          { "code": "4332", "name": "Joinery installation" },
          { "code": "4333", "name": "Floor and wall covering" },
          { "code": "4334", "name": "Painting and glazing" },
          { "code": "4339", "name": "Other building completion and finishing" }
        ]
      },
      {
        "code": "439",
        "name": "Other specialised construction activities",
        "subSubIndustries": [
          { "code": "4391", "name": "Roofing activities" },
          { "code": "4399", "name": "Other specialised construction activities n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "45",
    "name": "Wholesale and retail trade and repair of motor vehicles and motorcycles",
    "subIndustries": [
      {
        "code": "451",
        "name": "Sale of motor vehicles",
        "subSubIndustries": [
          { "code": "4511", "name": "Sale of cars and light motor vehicles" },
          { "code": "4519", "name": "Sale of other motor vehicles" }
        ]
      },
      {
        "code": "452",
        "name": "Maintenance and repair of motor vehicles",
        "subSubIndustries": [
          { "code": "4520", "name": "Maintenance and repair of motor vehicles" }
        ]
      },
      {
        "code": "453",
        "name": "Sale of motor vehicle parts and accessories",
        "subSubIndustries": [
          { "code": "4531", "name": "Wholesale trade of motor vehicle parts and accessories" },
          { "code": "4532", "name": "Retail trade of motor vehicle parts and accessories" }
        ]
      },
      {
        "code": "454",
        "name": "Sale, maintenance and repair of motorcycles and related parts and accessories",
        "subSubIndustries": [
          { "code": "4540", "name": "Sale, maintenance and repair of motorcycles and related parts and accessories" }
        ]
      }
    ]
  },
  {
    "code": "46",
    "name": "Wholesale trade, except of motor vehicles and motorcycles",
    "subIndustries": [
      {
        "code": "461",
        "name": "Wholesale on a fee or contract basis",
        "subSubIndustries": [
          { "code": "4611", "name": "Agents involved in the sale of agricultural raw materials, live animals, textile raw materials and semi-finished goods" },
          { "code": "4612", "name": "Agents involved in the sale of fuels, ores, metals and industrial chemicals" },
          { "code": "4613", "name": "Agents involved in the sale of timber and building materials" },
          { "code": "4614", "name": "Agents involved in the sale of machinery, industrial equipment, ships and aircraft" },
          { "code": "4615", "name": "Agents involved in the sale of furniture, household goods, hardware and ironmongery" },
          { "code": "4616", "name": "Agents involved in the sale of textiles, clothing, fur, footwear and leather goods" },
          { "code": "4617", "name": "Agents involved in the sale of food, beverages and tobacco" },
          { "code": "4618", "name": "Agents specialised in the sale of other particular products" },
          { "code": "4619", "name": "Agents involved in the sale of a variety of goods" }
        ]
      },
      {
        "code": "462",
        "name": "Wholesale of agricultural raw materials and live animals",
        "subSubIndustries": [
          { "code": "4621", "name": "Wholesale of grain, unmanufactured tobacco, seeds and animal feeds" },
          { "code": "4622", "name": "Wholesale of flowers and plants" },
          { "code": "4623", "name": "Wholesale of live animals" },
          { "code": "4624", "name": "Wholesale of hides, skins and leather" }
        ]
      },
      {
        "code": "463",
        "name": "Wholesale of food, beverages and tobacco",
        "subSubIndustries": [
          { "code": "4631", "name": "Wholesale of fruit and vegetables" },
          { "code": "4632", "name": "Wholesale of meat and meat products" },
          { "code": "4633", "name": "Wholesale of dairy products, eggs and edible oils and fats" },
          { "code": "4634", "name": "Wholesale of beverages" },
          { "code": "4635", "name": "Wholesale of tobacco products" },
          { "code": "4636", "name": "Wholesale of sugar, chocolate and sugar confectionery" },
          { "code": "4637", "name": "Wholesale of coffee, tea, cocoa and spices" },
          { "code": "4638", "name": "Wholesale of other food, including fish, crustaceans and molluscs" },
          { "code": "4639", "name": "Non-specialised wholesale of food, beverages and tobacco" }
        ]
      }
    ]
  },
  {
    "code": "47",
    "name": "Retail trade, except of motor vehicles and motorcycles",
    "subIndustries": [
      {
        "code": "471",
        "name": "Retail sale in non-specialised stores",
        "subSubIndustries": [
          { "code": "4711", "name": "Retail sale in non-specialised stores with food, beverages or tobacco predominating" },
          { "code": "4719", "name": "Other retail sale in non-specialised stores" }
        ]
      },
      {
        "code": "472",
        "name": "Retail sale of food, beverages and tobacco in specialised stores",
        "subSubIndustries": [
          { "code": "4721", "name": "Retail sale of fruit and vegetables in specialised stores" },
          { "code": "4722", "name": "Retail sale of meat and meat products in specialised stores" },
          { "code": "4723", "name": "Retail sale of fish, crustaceans and molluscs in specialised stores" },
          { "code": "4724", "name": "Retail sale of bread, cakes, flour confectionery and sugar confectionery in specialised stores" },
          { "code": "4725", "name": "Retail sale of beverages in specialised stores" },
          { "code": "4726", "name": "Retail sale of tobacco products in specialised stores" },
          { "code": "4729", "name": "Other retail sale of food in specialised stores" }
        ]
      },
      {
        "code": "473",
        "name": "Retail sale of automotive fuel in specialised stores",
        "subSubIndustries": [
          { "code": "4730", "name": "Retail sale of automotive fuel in specialised stores" }
        ]
      },
      {
        "code": "474",
        "name": "Retail sale of information and communication equipment in specialised stores",
        "subSubIndustries": [
          { "code": "4741", "name": "Retail sale of computers, peripheral units and software in specialised stores" },
          { "code": "4742", "name": "Retail sale of telecommunications equipment in specialised stores" },
          { "code": "4743", "name": "Retail sale of audio and video equipment in specialised stores" }
        ]
      }
    ]
  },
  {
    "code": "49",
    "name": "Land transport and transport via pipelines",
    "subIndustries": [
      {
        "code": "491",
        "name": "Passenger rail transport, interurban",
        "subSubIndustries": [
          { "code": "4910", "name": "Passenger rail transport, interurban" }
        ]
      },
      {
        "code": "492",
        "name": "Freight rail transport",
        "subSubIndustries": [
          { "code": "4920", "name": "Freight rail transport" }
        ]
      },
      {
        "code": "493",
        "name": "Other passenger land transport",
        "subSubIndustries": [
          { "code": "4931", "name": "Urban and suburban passenger land transport" },
          { "code": "4932", "name": "Taxi operation" },
          { "code": "4939", "name": "Other passenger land transport n.e.c." }
        ]
      },
      {
        "code": "494",
        "name": "Freight transport by road and removal services",
        "subSubIndustries": [
          { "code": "4941", "name": "Freight transport by road" },
          { "code": "4942", "name": "Removal services" }
        ]
      },
      {
        "code": "495",
        "name": "Transport via pipeline",
        "subSubIndustries": [
          { "code": "4950", "name": "Transport via pipeline" }
        ]
      }
    ]
  },
  {
    "code": "50",
    "name": "Water transport",
    "subIndustries": [
      {
        "code": "501",
        "name": "Sea and coastal passenger water transport",
        "subSubIndustries": [
          { "code": "5010", "name": "Sea and coastal passenger water transport" }
        ]
      },
      {
        "code": "502",
        "name": "Sea and coastal freight water transport",
        "subSubIndustries": [
          { "code": "5020", "name": "Sea and coastal freight water transport" }
        ]
      },
      {
        "code": "503",
        "name": "Inland passenger water transport",
        "subSubIndustries": [
          { "code": "5030", "name": "Inland passenger water transport" }
        ]
      },
      {
        "code": "504",
        "name": "Inland freight water transport",
        "subSubIndustries": [
          { "code": "5040", "name": "Inland freight water transport" }
        ]
      }
    ]
  },
  {
    "code": "51",
    "name": "Air transport",
    "subIndustries": [
      {
        "code": "511",
        "name": "Passenger air transport",
        "subSubIndustries": [
          { "code": "5110", "name": "Passenger air transport" }
        ]
      },
      {
        "code": "512",
        "name": "Freight air transport and space transport",
        "subSubIndustries": [
          { "code": "5121", "name": "Freight air transport" },
          { "code": "5122", "name": "Space transport" }
        ]
      }
    ]
  },
  {
    "code": "52",
    "name": "Warehousing and support activities for transportation",
    "subIndustries": [
      {
        "code": "521",
        "name": "Warehousing and storage",
        "subSubIndustries": [
          { "code": "5210", "name": "Warehousing and storage" }
        ]
      },
      {
        "code": "522",
        "name": "Support activities for transportation",
        "subSubIndustries": [
          { "code": "5221", "name": "Service activities incidental to land transportation" },
          { "code": "5222", "name": "Service activities incidental to water transportation" },
          { "code": "5223", "name": "Service activities incidental to air transportation" },
          { "code": "5224", "name": "Cargo handling" },
          { "code": "5229", "name": "Other transportation support activities" }
        ]
      }
    ]
  },
  {
    "code": "53",
    "name": "Postal and courier activities",
    "subIndustries": [
      {
        "code": "531",
        "name": "Postal activities under universal service obligation",
        "subSubIndustries": [
          { "code": "5310", "name": "Postal activities under universal service obligation" }
        ]
      },
      {
        "code": "532",
        "name": "Other postal and courier activities",
        "subSubIndustries": [
          { "code": "5320", "name": "Other postal and courier activities" }
        ]
      }
    ]
  },
  {
    "code": "55",
    "name": "Accommodation",
    "subIndustries": [
      {
        "code": "551",
        "name": "Hotels and similar accommodation",
        "subSubIndustries": [
          { "code": "5510", "name": "Hotels and similar accommodation" }
        ]
      },
      {
        "code": "552",
        "name": "Holiday and other short-stay accommodation",
        "subSubIndustries": [
          { "code": "5520", "name": "Holiday and other short-stay accommodation" }
        ]
      },
      {
        "code": "553",
        "name": "Camping grounds, recreational vehicle parks and trailer parks",
        "subSubIndustries": [
          { "code": "5530", "name": "Camping grounds, recreational vehicle parks and trailer parks" }
        ]
      },
      {
        "code": "559",
        "name": "Other accommodation",
        "subSubIndustries": [
          { "code": "5590", "name": "Other accommodation" }
        ]
      }
    ]
  },
  {
    "code": "56",
    "name": "Food and beverage service activities",
    "subIndustries": [
      {
        "code": "561",
        "name": "Restaurants and mobile food service activities",
        "subSubIndustries": [
          { "code": "5610", "name": "Restaurants and mobile food service activities" }
        ]
      },
      {
        "code": "562",
        "name": "Event catering and other food service activities",
        "subSubIndustries": [
          { "code": "5621", "name": "Event catering activities" },
          { "code": "5629", "name": "Other food service activities" }
        ]
      },
      {
        "code": "563",
        "name": "Beverage serving activities",
        "subSubIndustries": [
          { "code": "5630", "name": "Beverage serving activities" }
        ]
      }
    ]
  },
  {
    "code": "58",
    "name": "Publishing activities",
    "subIndustries": [
      {
        "code": "581",
        "name": "Publishing of books, periodicals and other publishing activities",
        "subSubIndustries": [
          { "code": "5811", "name": "Book publishing" },
          { "code": "5812", "name": "Publishing of directories and mailing lists" },
          { "code": "5813", "name": "Publishing of newspapers" },
          { "code": "5814", "name": "Publishing of journals and periodicals" },
          { "code": "5819", "name": "Other publishing activities" }
        ]
      },
      {
        "code": "582",
        "name": "Software publishing",
        "subSubIndustries": [
          { "code": "5821", "name": "Publishing of computer games" },
          { "code": "5829", "name": "Other software publishing" }
        ]
      }
    ]
  },
  {
    "code": "59",
    "name": "Motion picture, video and television programme production, sound recording and music publishing activities",
    "subIndustries": [
      {
        "code": "591",
        "name": "Motion picture, video and television programme activities",
        "subSubIndustries": [
          { "code": "5911", "name": "Motion picture, video and television programme production activities" },
          { "code": "5912", "name": "Motion picture, video and television programme post-production activities" },
          { "code": "5913", "name": "Motion picture, video and television programme distribution activities" },
          { "code": "5914", "name": "Motion picture projection activities" }
        ]
      },
      {
        "code": "592",
        "name": "Sound recording and music publishing activities",
        "subSubIndustries": [
          { "code": "5920", "name": "Sound recording and music publishing activities" }
        ]
      }
    ]
  },
  {
    "code": "60",
    "name": "Programming and broadcasting activities",
    "subIndustries": [
      {
        "code": "601",
        "name": "Radio broadcasting",
        "subSubIndustries": [
          { "code": "6010", "name": "Radio broadcasting" }
        ]
      },
      {
        "code": "602",
        "name": "Television programming and broadcasting activities",
        "subSubIndustries": [
          { "code": "6020", "name": "Television programming and broadcasting activities" }
        ]
      }
    ]
  },
  {
    "code": "61",
    "name": "Telecommunications",
    "subIndustries": [
      {
        "code": "611",
        "name": "Wired telecommunications activities",
        "subSubIndustries": [
          { "code": "6110", "name": "Wired telecommunications activities" }
        ]
      },
      {
        "code": "612",
        "name": "Wireless telecommunications activities",
        "subSubIndustries": [
          { "code": "6120", "name": "Wireless telecommunications activities" }
        ]
      },
      {
        "code": "613",
        "name": "Satellite telecommunications activities",
        "subSubIndustries": [
          { "code": "6130", "name": "Satellite telecommunications activities" }
        ]
      },
      {
        "code": "619",
        "name": "Other telecommunications activities",
        "subSubIndustries": [
          { "code": "6190", "name": "Other telecommunications activities" }
        ]
      }
    ]
  },
  {
    "code": "62",
    "name": "Computer programming, consultancy and related activities",
    "subIndustries": [
      {
        "code": "620",
        "name": "Computer programming, consultancy and related activities",
        "subSubIndustries": [
          { "code": "6201", "name": "Computer programming activities" },
          { "code": "6202", "name": "Computer consultancy activities" },
          { "code": "6203", "name": "Computer facilities management activities" },
          { "code": "6209", "name": "Other information technology and computer service activities" }
        ]
      }
    ]
  },
  {
    "code": "63",
    "name": "Information service activities",
    "subIndustries": [
      {
        "code": "631",
        "name": "Data processing, hosting and related activities; web portals",
        "subSubIndustries": [
          { "code": "6311", "name": "Data processing, hosting and related activities" },
          { "code": "6312", "name": "Web portals" }
        ]
      },
      {
        "code": "639",
        "name": "Other information service activities",
        "subSubIndustries": [
          { "code": "6391", "name": "News agency activities" },
          { "code": "6399", "name": "Other information service activities n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "64",
    "name": "Financial service activities, except insurance and pension funding",
    "subIndustries": [
      {
        "code": "641",
        "name": "Monetary intermediation",
        "subSubIndustries": [
          { "code": "6411", "name": "Central banking" },
          { "code": "6419", "name": "Other monetary intermediation" }
        ]
      },
      {
        "code": "642",
        "name": "Activities of holding companies",
        "subSubIndustries": [
          { "code": "6420", "name": "Activities of holding companies" }
        ]
      },
      {
        "code": "643",
        "name": "Trusts, funds and similar financial entities",
        "subSubIndustries": [
          { "code": "6430", "name": "Trusts, funds and similar financial entities" }
        ]
      },
      {
        "code": "649",
        "name": "Other financial service activities, except insurance and pension funding",
        "subSubIndustries": [
          { "code": "6491", "name": "Financial leasing" },
          { "code": "6492", "name": "Other credit granting" },
          { "code": "6499", "name": "Other financial service activities, except insurance and pension funding n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "65",
    "name": "Insurance, reinsurance and pension funding, except compulsory social security",
    "subIndustries": [
      {
        "code": "651",
        "name": "Insurance",
        "subSubIndustries": [
          { "code": "6511", "name": "Life insurance" },
          { "code": "6512", "name": "Non-life insurance" }
        ]
      },
      {
        "code": "652",
        "name": "Reinsurance",
        "subSubIndustries": [
          { "code": "6520", "name": "Reinsurance" }
        ]
      },
      {
        "code": "653",
        "name": "Pension funding",
        "subSubIndustries": [
          { "code": "6530", "name": "Pension funding" }
        ]
      }
    ]
  },
  {
    "code": "66",
    "name": "Activities auxiliary to financial services and insurance activities",
    "subIndustries": [
      {
        "code": "661",
        "name": "Activities auxiliary to financial services, except insurance and pension funding",
        "subSubIndustries": [
          { "code": "6611", "name": "Administration of financial markets" },
          { "code": "6612", "name": "Security and commodity contracts brokerage" },
          { "code": "6619", "name": "Other activities auxiliary to financial services, except insurance and pension funding" }
        ]
      },
      {
        "code": "662",
        "name": "Activities auxiliary to insurance and pension funding",
        "subSubIndustries": [
          { "code": "6621", "name": "Risk and damage evaluation" },
          { "code": "6622", "name": "Activities of insurance agents and brokers" },
          { "code": "6629", "name": "Other activities auxiliary to insurance and pension funding" }
        ]
      },
      {
        "code": "663",
        "name": "Fund management activities",
        "subSubIndustries": [
          { "code": "6630", "name": "Fund management activities" }
        ]
      }
    ]
  },
  {
    "code": "68",
    "name": "Real estate activities",
    "subIndustries": [
      {
        "code": "681",
        "name": "Buying and selling of own real estate",
        "subSubIndustries": [
          { "code": "6810", "name": "Buying and selling of own real estate" }
        ]
      },
      {
        "code": "682",
        "name": "Rental and operating of own or leased real estate",
        "subSubIndustries": [
          { "code": "6820", "name": "Rental and operating of own or leased real estate" }
        ]
      },
      {
        "code": "683",
        "name": "Real estate activities on a fee or contract basis",
        "subSubIndustries": [
          { "code": "6831", "name": "Real estate agencies" },
          { "code": "6832", "name": "Management of real estate on a fee or contract basis" }
        ]
      }
    ]
  },
  {
    "code": "69",
    "name": "Legal and accounting activities",
    "subIndustries": [
      {
        "code": "691",
        "name": "Legal activities",
        "subSubIndustries": [
          { "code": "6910", "name": "Legal activities" }
        ]
      },
      {
        "code": "692",
        "name": "Accounting, bookkeeping, and auditing activities; tax consultancy",
        "subSubIndustries": [
          { "code": "6920", "name": "Accounting, bookkeeping, and auditing activities; tax consultancy" }
        ]
      }
    ]
  },
  {
    "code": "70",
    "name": "Activities of head offices; management consultancy activities",
    "subIndustries": [
      {
        "code": "701",
        "name": "Activities of head offices",
        "subSubIndustries": [
          { "code": "7010", "name": "Activities of head offices" }
        ]
      },
      {
        "code": "702",
        "name": "Management consultancy activities",
        "subSubIndustries": [
          { "code": "7021", "name": "Public relations and communication activities" },
          { "code": "7022", "name": "Business and other management consultancy activities" }
        ]
      }
    ]
  },
  {
    "code": "71",
    "name": "Architectural and engineering activities; technical testing and analysis",
    "subIndustries": [
      {
        "code": "711",
        "name": "Architectural and engineering activities and related technical consultancy",
        "subSubIndustries": [
          { "code": "7111", "name": "Architectural activities" },
          { "code": "7112", "name": "Engineering activities and related technical consultancy" }
        ]
      },
      {
        "code": "712",
        "name": "Technical testing and analysis",
        "subSubIndustries": [
          { "code": "7120", "name": "Technical testing and analysis" }
        ]
      }
    ]
  },
  {
    "code": "72",
    "name": "Scientific research and development",
    "subIndustries": [
      {
        "code": "721",
        "name": "Research and experimental development on natural sciences and engineering",
        "subSubIndustries": [
          { "code": "7211", "name": "Research and experimental development on biotechnology" },
          { "code": "7219", "name": "Other research and experimental development on natural sciences and engineering" }
        ]
      },
      {
        "code": "722",
        "name": "Research and experimental development on social sciences and humanities",
        "subSubIndustries": [
          { "code": "7220", "name": "Research and experimental development on social sciences and humanities" }
        ]
      }
    ]
  },
  {
    "code": "73",
    "name": "Advertising and market research",
    "subIndustries": [
      {
        "code": "731",
        "name": "Advertising",
        "subSubIndustries": [
          { "code": "7311", "name": "Advertising agencies" },
          { "code": "7312", "name": "Media representation" }
        ]
      },
      {
        "code": "732",
        "name": "Market research and public opinion polling",
        "subSubIndustries": [
          { "code": "7320", "name": "Market research and public opinion polling" }
        ]
      }
    ]
  },
  {
    "code": "74",
    "name": "Other professional, scientific and technical activities",
    "subIndustries": [
      {
        "code": "741",
        "name": "Specialized design activities",
        "subSubIndustries": [
          { "code": "7410", "name": "Specialized design activities" }
        ]
      },
      {
        "code": "742",
        "name": "Photographic activities",
        "subSubIndustries": [
          { "code": "7420", "name": "Photographic activities" }
        ]
      },
      {
        "code": "743",
        "name": "Translation and interpretation activities",
        "subSubIndustries": [
          { "code": "7430", "name": "Translation and interpretation activities" }
        ]
      },
      {
        "code": "749",
        "name": "Other professional, scientific and technical activities n.e.c.",
        "subSubIndustries": [
          { "code": "7490", "name": "Other professional, scientific and technical activities n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "75",
    "name": "Veterinary activities",
    "subIndustries": [
      {
        "code": "750",
        "name": "Veterinary activities",
        "subSubIndustries": [
          { "code": "7500", "name": "Veterinary activities" }
        ]
      }
    ]
  },
  {
    "code": "77",
    "name": "Rental and leasing activities",
    "subIndustries": [
      {
        "code": "771",
        "name": "Rental and leasing of motor vehicles",
        "subSubIndustries": [
          { "code": "7711", "name": "Rental and leasing of cars and light motor vehicles" },
          { "code": "7712", "name": "Rental and leasing of trucks" }
        ]
      },
      {
        "code": "772",
        "name": "Rental and leasing of personal and household goods",
        "subSubIndustries": [
          { "code": "7721", "name": "Rental and leasing of recreational and sports goods" },
          { "code": "7722", "name": "Rental of video tapes and disks" },
          { "code": "7729", "name": "Rental and leasing of other personal and household goods" }
        ]
      },
      {
        "code": "773",
        "name": "Rental and leasing of other machinery, equipment, and tangible goods",
        "subSubIndustries": [
          { "code": "7731", "name": "Rental and leasing of agricultural machinery and equipment" },
          { "code": "7732", "name": "Rental and leasing of construction and civil engineering machinery and equipment" },
          { "code": "7733", "name": "Rental and leasing of office machinery and equipment (including computers)" },
          { "code": "7734", "name": "Rental and leasing of water transport equipment" },
          { "code": "7735", "name": "Rental and leasing of air transport equipment" },
          { "code": "7739", "name": "Rental and leasing of other machinery, equipment, and tangible goods n.e.c." }
        ]
      },
      {
        "code": "774",
        "name": "Leasing of intellectual property and similar products, except copyrighted works",
        "subSubIndustries": [
          { "code": "7740", "name": "Leasing of intellectual property and similar products, except copyrighted works" }
        ]
      }
    ]
  },
  {
    "code": "78",
    "name": "Employment activities",
    "subIndustries": [
      {
        "code": "781",
        "name": "Activities of employment placement agencies",
        "subSubIndustries": [
          { "code": "7810", "name": "Activities of employment placement agencies" }
        ]
      },
      {
        "code": "782",
        "name": "Temporary employment agency activities",
        "subSubIndustries": [
          { "code": "7820", "name": "Temporary employment agency activities" }
        ]
      },
      {
        "code": "783",
        "name": "Other human resources provision",
        "subSubIndustries": [
          { "code": "7830", "name": "Other human resources provision" }
        ]
      }
    ]
  },
  {
    "code": "79",
    "name": "Travel agency, tour operator, and other reservation service and related activities",
    "subIndustries": [
      {
        "code": "791",
        "name": "Travel agency and tour operator activities",
        "subSubIndustries": [
          { "code": "7911", "name": "Travel agency activities" },
          { "code": "7912", "name": "Tour operator activities" }
        ]
      },
      {
        "code": "799",
        "name": "Other reservation service and related activities",
        "subSubIndustries": [
          { "code": "7990", "name": "Other reservation service and related activities" }
        ]
      }
    ]
  },
  {
    "code": "80",
    "name": "Security and investigation activities",
    "subIndustries": [
      {
        "code": "801",
        "name": "Private security activities",
        "subSubIndustries": [
          { "code": "8010", "name": "Private security activities" }
        ]
      },
      {
        "code": "802",
        "name": "Security systems service activities",
        "subSubIndustries": [
          { "code": "8020", "name": "Security systems service activities" }
        ]
      },
      {
        "code": "803",
        "name": "Investigation activities",
        "subSubIndustries": [
          { "code": "8030", "name": "Investigation activities" }
        ]
      }
    ]
  },
  {
    "code": "81",
    "name": "Services to buildings and landscape activities",
    "subIndustries": [
      {
        "code": "811",
        "name": "Combined facilities support activities",
        "subSubIndustries": [
          { "code": "8110", "name": "Combined facilities support activities" }
        ]
      },
      {
        "code": "812",
        "name": "Cleaning activities",
        "subSubIndustries": [
          { "code": "8121", "name": "General cleaning of buildings" },
          { "code": "8122", "name": "Other building and industrial cleaning activities" },
          { "code": "8129", "name": "Other cleaning activities" }
        ]
      },
      {
        "code": "813",
        "name": "Landscape service activities",
        "subSubIndustries": [
          { "code": "8130", "name": "Landscape service activities" }
        ]
      }
    ]
  },
  {
    "code": "82",
    "name": "Office administrative, office support, and other business support activities",
    "subIndustries": [
      {
        "code": "821",
        "name": "Office administrative and support activities",
        "subSubIndustries": [
          { "code": "8211", "name": "Combined office administrative service activities" },
          { "code": "8219", "name": "Photocopying, document preparation, and other specialized office support activities" }
        ]
      },
      {
        "code": "822",
        "name": "Activities of call centers",
        "subSubIndustries": [
          { "code": "8220", "name": "Activities of call centers" }
        ]
      },
      {
        "code": "823",
        "name": "Organization of conventions and trade shows",
        "subSubIndustries": [
          { "code": "8230", "name": "Organization of conventions and trade shows" }
        ]
      },
      {
        "code": "829",
        "name": "Business support service activities n.e.c.",
        "subSubIndustries": [
          { "code": "8291", "name": "Activities of collection agencies and credit bureaus" },
          { "code": "8292", "name": "Packaging activities" },
          { "code": "8299", "name": "Other business support service activities n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "84",
    "name": "Public administration and defence; compulsory social security",
    "subIndustries": [
      {
        "code": "841",
        "name": "Administration of the State and the economic and social policy of the community",
        "subSubIndustries": [
          { "code": "8411", "name": "General public administration activities" },
          { "code": "8412", "name": "Regulation of health care, education, cultural and other social services, excluding social security" },
          { "code": "8413", "name": "Regulation of and contribution to more efficient operation of businesses" }
        ]
      },
      {
        "code": "842",
        "name": "Provision of services to the community as a whole",
        "subSubIndustries": [
          { "code": "8421", "name": "Foreign affairs" },
          { "code": "8422", "name": "Defence activities" },
          { "code": "8423", "name": "Justice and judicial activities" },
          { "code": "8424", "name": "Public order and safety activities" },
          { "code": "8425", "name": "Fire service activities" }
        ]
      },
      {
        "code": "843",
        "name": "Compulsory social security activities",
        "subSubIndustries": [
          { "code": "8430", "name": "Compulsory social security activities" }
        ]
      }
    ]
  },
  {
    "code": "85",
    "name": "Education",
    "subIndustries": [
      {
        "code": "851",
        "name": "Pre-primary and primary education",
        "subSubIndustries": [
          { "code": "8510", "name": "Pre-primary education" },
          { "code": "8520", "name": "Primary education" }
        ]
      },
      {
        "code": "853",
        "name": "Secondary education",
        "subSubIndustries": [
          { "code": "8531", "name": "General secondary education" },
          { "code": "8532", "name": "Technical and vocational secondary education" }
        ]
      },
      {
        "code": "854",
        "name": "Higher education",
        "subSubIndustries": [
          { "code": "8541", "name": "Post-secondary non-tertiary education" },
          { "code": "8542", "name": "Tertiary education" }
        ]
      },
      {
        "code": "855",
        "name": "Other education",
        "subSubIndustries": [
          { "code": "8551", "name": "Sports and recreation education" },
          { "code": "8552", "name": "Cultural education" },
          { "code": "8553", "name": "Driving school activities" },
          { "code": "8559", "name": "Other education n.e.c." }
        ]
      },
      {
        "code": "856",
        "name": "Educational support activities",
        "subSubIndustries": [
          { "code": "8560", "name": "Educational support activities" }
        ]
      }
    ]
  },
  {
    "code": "86",
    "name": "Human health activities",
    "subIndustries": [
      {
        "code": "861",
        "name": "Hospital activities",
        "subSubIndustries": [
          { "code": "8610", "name": "Hospital activities" }
        ]
      },
      {
        "code": "862",
        "name": "Medical and dental practice activities",
        "subSubIndustries": [
          { "code": "8621", "name": "General medical practice activities" },
          { "code": "8622", "name": "Specialist medical practice activities" },
          { "code": "8623", "name": "Dental practice activities" }
        ]
      },
      {
        "code": "869",
        "name": "Other human health activities",
        "subSubIndustries": [
          { "code": "8690", "name": "Other human health activities" }
        ]
      }
    ]
  },
  {
    "code": "87",
    "name": "Residential care activities",
    "subIndustries": [
      {
        "code": "871",
        "name": "Residential nursing care facilities",
        "subSubIndustries": [
          { "code": "8710", "name": "Residential nursing care facilities" }
        ]
      },
      {
        "code": "872",
        "name": "Residential care activities for mental retardation, mental health, and substance abuse",
        "subSubIndustries": [
          { "code": "8720", "name": "Residential care activities for mental retardation, mental health, and substance abuse" }
        ]
      },
      {
        "code": "873",
        "name": "Residential care activities for the elderly and disabled",
        "subSubIndustries": [
          { "code": "8730", "name": "Residential care activities for the elderly and disabled" }
        ]
      },
      {
        "code": "879",
        "name": "Other residential care activities",
        "subSubIndustries": [
          { "code": "8790", "name": "Other residential care activities" }
        ]
      }
    ]
  },
  {
    "code": "88",
    "name": "Social work activities without accommodation",
    "subIndustries": [
      {
        "code": "881",
        "name": "Social work activities without accommodation for the elderly and disabled",
        "subSubIndustries": [
          { "code": "8810", "name": "Social work activities without accommodation for the elderly and disabled" }
        ]
      },
      {
        "code": "889",
        "name": "Other social work activities without accommodation",
        "subSubIndustries": [
          { "code": "8891", "name": "Child day-care activities" },
          { "code": "8899", "name": "Other social work activities without accommodation n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "90",
    "name": "Creative, arts, and entertainment activities",
    "subIndustries": [
      {
        "code": "900",
        "name": "Creative, arts, and entertainment activities",
        "subSubIndustries": [
          { "code": "9001", "name": "Performing arts" },
          { "code": "9002", "name": "Support activities to performing arts" },
          { "code": "9003", "name": "Artistic creation" },
          { "code": "9004", "name": "Operation of arts facilities" }
        ]
      }
    ]
  },
  {
    "code": "91",
    "name": "Libraries, archives, museums, and other cultural activities",
    "subIndustries": [
      {
        "code": "910",
        "name": "Libraries, archives, museums, and other cultural activities",
        "subSubIndustries": [
          { "code": "9101", "name": "Library and archive activities" },
          { "code": "9102", "name": "Museum activities" },
          { "code": "9103", "name": "Operation of historical sites and buildings and similar visitor attractions" },
          { "code": "9104", "name": "Botanical and zoological gardens and nature reserves activities" }
        ]
      }
    ]
  },
  {
    "code": "92",
    "name": "Gambling and betting activities",
    "subIndustries": [
      {
        "code": "920",
        "name": "Gambling and betting activities",
        "subSubIndustries": [
          { "code": "9200", "name": "Gambling and betting activities" }
        ]
      }
    ]
  },
  {
    "code": "93",
    "name": "Sports activities and amusement and recreation activities",
    "subIndustries": [
      {
        "code": "931",
        "name": "Sports activities",
        "subSubIndustries": [
          { "code": "9311", "name": "Operation of sports facilities" },
          { "code": "9312", "name": "Activities of sports clubs" },
          { "code": "9313", "name": "Fitness facilities" },
          { "code": "9319", "name": "Other sports activities" }
        ]
      },
      {
        "code": "932",
        "name": "Amusement and recreation activities",
        "subSubIndustries": [
          { "code": "9321", "name": "Activities of amusement parks and theme parks" },
          { "code": "9329", "name": "Other amusement and recreation activities" }
        ]
      }
    ]
  },
  {
    "code": "94",
    "name": "Activities of membership organizations",
    "subIndustries": [
      {
        "code": "941",
        "name": "Activities of business, employers, and professional membership organizations",
        "subSubIndustries": [
          { "code": "9411", "name": "Activities of business and employers' membership organizations" },
          { "code": "9412", "name": "Activities of professional membership organizations" }
        ]
      },
      {
        "code": "942",
        "name": "Activities of trade unions",
        "subSubIndustries": [
          { "code": "9420", "name": "Activities of trade unions" }
        ]
      },
      {
        "code": "949",
        "name": "Activities of other membership organizations",
        "subSubIndustries": [
          { "code": "9491", "name": "Activities of religious organizations" },
          { "code": "9492", "name": "Activities of political organizations" },
          { "code": "9499", "name": "Activities of other membership organizations n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "95",
    "name": "Repair of computers and personal and household goods",
    "subIndustries": [
      {
        "code": "951",
        "name": "Repair of computers and communication equipment",
        "subSubIndustries": [
          { "code": "9511", "name": "Repair of computers and peripheral equipment" },
          { "code": "9512", "name": "Repair of communication equipment" }
        ]
      },
      {
        "code": "952",
        "name": "Repair of personal and household goods",
        "subSubIndustries": [
          { "code": "9521", "name": "Repair of consumer electronics" },
          { "code": "9522", "name": "Repair of household appliances and home and garden equipment" },
          { "code": "9523", "name": "Repair of footwear and leather goods" },
          { "code": "9524", "name": "Repair of furniture and home furnishings" },
          { "code": "9525", "name": "Repair of watches, clocks, and jewelry" },
          { "code": "9529", "name": "Repair of other personal and household goods" }
        ]
      }
    ]
  },
  {
    "code": "96",
    "name": "Other personal service activities",
    "subIndustries": [
      {
        "code": "960",
        "name": "Other personal service activities",
        "subSubIndustries": [
          { "code": "9601", "name": "Washing and (dry-)cleaning of textile and fur products" },
          { "code": "9602", "name": "Hairdressing and other beauty treatment" },
          { "code": "9603", "name": "Funeral and related activities" },
          { "code": "9604", "name": "Physical well-being activities" },
          { "code": "9609", "name": "Other personal service activities n.e.c." }
        ]
      }
    ]
  },
  {
    "code": "97",
    "name": "Activities of households as employers of domestic personnel",
    "subIndustries": [
      {
        "code": "970",
        "name": "Activities of households as employers of domestic personnel",
        "subSubIndustries": [
          { "code": "9700", "name": "Activities of households as employers of domestic personnel" }
        ]
      }
    ]
  },
  {
    "code": "98",
    "name": "Undifferentiated goods- and services-producing activities of private households for own use",
    "subIndustries": [
      {
        "code": "981",
        "name": "Undifferentiated goods-producing activities of private households for own use",
        "subSubIndustries": [
          { "code": "9810", "name": "Undifferentiated goods-producing activities of private households for own use" }
        ]
      },
      {
        "code": "982",
        "name": "Undifferentiated service-producing activities of private households for own use",
        "subSubIndustries": [
          { "code": "9820", "name": "Undifferentiated service-producing activities of private households for own use" }
        ]
      }
    ]
  },
  {
    "code": "99",
    "name": "Activities of extraterritorial organizations and bodies",
    "subIndustries": [
      {
        "code": "990",
        "name": "Activities of extraterritorial organizations and bodies",
        "subSubIndustries": [
          { "code": "9900", "name": "Activities of extraterritorial organizations and bodies" }
        ]
      }
    ]
  }
];

// Export industries object
export default industries;
